import { render, staticRenderFns } from "./InfoUsuario.vue?vue&type=template&id=5850a279&"
import script from "./InfoUsuario.vue?vue&type=script&lang=js&"
export * from "./InfoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./InfoUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports